<div class="header">
  <div class="left">
    <div class="logo">
      <img src="/assets/stellantis/logo.jpg" alt="logo" width="200px" height="80px">
      <p>INTERNAL MARKETPLACE</p>
    </div>
    <!--    <div class="menu">-->
    <!--      <ul>-->
    <!--        <li>Home</li>-->
    <!--        <li>About</li>-->
    <!--        <li>Contact</li>-->
    <!--      </ul>-->
    <!--    </div>-->
  </div>
  <div class="right">
    <!--    <div class="search">-->
    <!--      <input type="text" placeholder="Search">-->
    <!--    </div>-->
    <!--    <div class="login">-->
    <!--      <button mat-stroked-button (click)="signout">Sign-out</button>-->
    <!--    </div>-->
    <div class="login">
      <button mat-stroked-button>{{ username }}</button>
    </div>
  </div>
</div>

<div class="banner">
  <div class="banner-right">
    <img src="/assets/stellantis/Jeep-1.jpg" height="200" width="400"/>
  </div>
  <div class="banner-left">
<!--    <img src="/assets/stellantis/brand-jeep.svg" height="100" width="200"/>-->
    <p style="font-weight: bolder;font-size: 14pt">STELLANTIS</p>
    <p style="font-size: 10pt">
      Stellantis is a constellation of 14 iconic automotive brands and two mobility arms that are about more than transportation: they’re about moving people and making connections.

      As we transform into a sustainable mobility tech company, we are guided by the clear vision of our Dare Forward 2030 strategic plan, which paves the way for Stellantis to achieve carbon net zero by 2038(1) and be second to none in value creation for all stakeholders.
    </p>


  </div>

</div>

<div class="content-container">


  <div class="layout-container">


    <ng-template #loadingOverlay>
      <div class="loading-overlay">
        <mat-spinner></mat-spinner>
      </div>
    </ng-template>
    <div id="cardContainer" #carContainer [class.car-container-desktop]="!isMobileView()"
         [class.car-container-mobile]="isMobileView()"
         class="car-container" dir="ltr">
      <div class="card-container">
        <mat-card
          [ngClass]="{'card-item-m': isMobileView(), 'card-item': !isMobileView(), 'authorized-border': car.authorized_seller, 'regular-border': !car.authorized_seller}"
          *ngFor="let car of cars" matRipple fxLayout="column" fxFlex>
          <!--        <mat-card [ngClass]="isMobileView() ? 'card-item-m' : 'card-item'" *ngFor="let car of cars" matRipple-->
          <!--                  fxLayout="column" fxFlex>-->
          <div style="height: 110px;width: calc(100% + 32px);margin: 0 -16px 0 -16px;" class="car-image-container">
            <img
              mat-card-image
              class="card-image"
              [appLazyLoad]="'assets/images/nocarph.jpg'"
              [targetImage]="car.url"
              alt="{{car.Manufacturer}} {{car.Model}}"
              (click)="openDialog(car)"
              height="110px"
            />

          </div>
          <!--          <fa-icon-->
          <!--            class="heart-icon"-->
          <!--            [icon]="car.isLiked ? fasFaHeart : farFaHeart"-->
          <!--            (click)="toggleLike(car)"-->
          <!--          ></fa-icon>-->

          <!--          <fa-icon *ngIf="car.myCarId !== null"-->
          <!--                   class="cart-icon"-->
          <!--                   [icon]="faShoppingCart"-->
          <!--          ></fa-icon>-->

          <!--          <svg-icon *ngIf="car.authorized_seller"-->
          <!--                    class="authorized"-->
          <!--                    [src]="'/assets/icons/certificate.svg'"-->
          <!--                    [svgStyle]="{width:'24px', height:'24px'}"-->
          <!--                    nbTooltip="ספק מאושר"-->
          <!--          ></svg-icon>-->

          <svg-icon
            class="location"
            [src]="'/assets/icons/countries/'+ car.country.toLowerCase() +'.svg'"
            [svgStyle]="{width:'16px'}"
            nbTooltip="{{car.country.toUpperCase()}}"
          ></svg-icon>

          <mat-card-content class="mat-card-content">
            <div (click)="handleClick(car)">
              <div class="m-1 pt-3">
                <div class="overview-style">
                  <div [ngStyle]="{ 'background-color': '#5f7dff', 'border-bottom': '0px' }"
                       class="overview-cart parent-cart">
                    <div class="inner-header flex-row">
                      <!--                    <span class=" mt-4 heading-text white size14" [className]="car.Manufacturer == 'Mercedes-Benz' ? 'size12' : 'size14'">{{ car.Manufacturer }}</span>-->
                      <span
                        class="mt-4 heading-text white"
                        [ngClass]="{ 'size12': car.Manufacturer === 'Mercedes-Benz', 'size14': car.Manufacturer !== 'Mercedes-Benz' }">
                      {{ car.Manufacturer }}
                    </span>
                      <span class="mt-4 heading-id-text size14">{{ car.id }}</span>
                      <img *ngIf="car.IsHot" class="mt-4 hot-icon" src="/assets/images/fire-30.png" alt="" width="25"
                           height="30"/>
                    </div>
                  </div>
                </div>
              </div>

              <div class="more-info">
                <div class="flex-row location-info">
                  <span class="flex-cell location-text mr-4 bold pull-left"
                        style="float:left;">{{ car.FuelType }}</span>
                  <span class="flex-cell location-text mr-4 bold pull-left truncate">{{ car.FinishLevel }}</span>
                  <span class="flex-cell location-text mr-4 bold pull-left truncate"
                        direction="ltr">{{ car.Model }}</span>

                </div>
                <div class="extra-info">
                  <div class="flex-table">
                    <div class="flex-row">
                      <!--                  <div class="flex-cell bold">מחיר</div>-->
                      <div *ngIf="importType === 'Commercial'" class="flex-cell bold big price">

                        {{ calcCost(car) |currency: 'EUR' : 'symbol' : '1.0-0' }}<br/>
                        <span class="small" style="font-size:8pt">
                      מחיר משוער לאחר שחרור מכס
                      </span>
                      </div>
                      <!--                      <div *ngIf="importType === 'Taxi'" class="flex-cell bold big price" style="height:55px">-->
                      <!--                        <div-->
                      <!--                          style="flex-direction: row; align-items: center; display: flex;justify-content: space-around">-->
                      <!--                          <div><img src="/assets/images/Taxi_logo.png" alt="" width="60" height="20"-->
                      <!--                                    style="border:2px solid black; border-radius: 4px"/></div>-->
                      <!--                          <span>{{ car.C_PriceComTaxi | currency: 'ILS' : 'symbol' : '1.0-0' }}</span>-->
                      <!--                        </div>-->
                      <!--                        <div style="margin-top: 0px;">-->
                      <!--                          <span class="small" style="font-size:8pt">מחיר משוער </span>-->
                      <!--                          <span class="small" style="font-size:9pt; font-weight: bold">למונית</span>-->
                      <!--                          <span class="small" style="font-size:8pt">לאחר שחרור מכס </span>-->
                      <!--                        </div>-->
                      <!--                      </div>-->
                    </div>
                    <div class="flex-row" *ngIf="showDirham">
                      <!--                  <div class="flex-cell bold">מחיר</div>-->
                      <div *ngIf="importType === 'Commercial'" class="flex-cell bold big price">
                        {{ getCarPrice(car) |currency: 'AED' : 'symbol' : '1.0-0' }}<br/>
                        <span class="small" style="font-size:8pt">
                      Estimated price after customs release
                      </span>
                      </div>
                      <!--                    <div *ngIf="importType === 'Taxi'" class="flex-cell bold big price" style="height:55px">-->
                      <!--                      <div-->
                      <!--                        style="flex-direction: row; align-items: center; display: flex;justify-content: space-around">-->
                      <!--                        <div><img src="/assets/images/Taxi_logo.png" alt="" width="60" height="20"-->
                      <!--                                  style="border:2px solid black; border-radius: 4px"/></div>-->
                      <!--                        <span>{{ car.C_PriceComTaxi | currency: 'ILS' : 'symbol' : '1.0-0' }}</span>-->
                      <!--                      </div>-->
                      <!--                      <div style="margin-top: 0px;">-->
                      <!--                        <span class="small" style="font-size:8pt">מחיר משוער </span>-->
                      <!--                        <span class="small" style="font-size:9pt; font-weight: bold">למונית</span>-->
                      <!--                        <span class="small" style="font-size:8pt">לאחר שחרור מכס </span>-->
                      <!--                      </div>-->
                      <!--                    </div>-->
                    </div>

                  </div>
                </div>
                <div class="extra-info-engine">
                  <div class="flex-row bold engine-text">
                    <div class="flex-cell">שנת ייצור</div>
                    <div class="flex-cell">{{ car.ManufactureDate | date:'yyyy' }}</div>
                  </div>
                </div>
                <div class="extra-info-engine">
                  <div class="flex-row bold engine-text">
                    <div class="flex-cell">צבע</div>
                    <div class="flex-cell">{{ car.ExteriorColor }}</div>
                  </div>
                </div>
                <div class="extra-info-engine">
                  <div *ngIf="car.Mileage" class="flex-row bold engine-text">
                    <div class="flex-cell">קילומטראג׳</div>
                    <div class="flex-cell">{{ car.Mileage | number: '1.0-0' }}</div>
                  </div>
                </div>
                <div class="extra-info-engine">
                  <div *ngIf="car.engine" class="flex-row bold engine-text">
                    <div class="flex-cell">מנוע</div>
                    <div class="flex-cell">{{ car.engine }}</div>
                  </div>
                </div>

              </div>

              <!--            <div class="card-actions">-->
              <!--              <button id="cars-grid-more-info-button"-->
              <!--                      mat-raised-button-->
              <!--                      color="primary"-->
              <!--                      class="interested-button full-width"-->
              <!--                      (click)="handleClick(car)"-->
              <!--              >פרטים נוספים-->
              <!--              </button>-->
              <!--            </div>-->
            </div>
          </mat-card-content>
        </mat-card>
        <div class="spinner-container" *ngIf="isLoading && hasMore">
          <mat-progress-spinner mode="indeterminate" [diameter]="50"></mat-progress-spinner>
        </div>
      </div>
    </div>
    <button class="filter-toggle-button" (click)="toggleFilter()" *ngIf="isMobileView()">
      <i [ngClass]="isFilterCollapsed ? 'fas fa-filter' : 'fas fa-times'"></i>
      <!-- Switch between filter and close icons -->
    </button>
    <ng-container #host style="display: none"></ng-container>


  </div>
</div>


